// localStorage can be unavailable (private windows, blocked site data); everything kept there is a
// convenience, so reads fall back to nothing and writes fail silently.

export function readStorage(key: string): string | null {
  try {
    return window.localStorage.getItem(key)
  } catch {
    return null
  }
}

/** Stores the value, or removes the key for `null`. */
export function writeStorage(key: string, value: string | null): void {
  try {
    if (value === null) window.localStorage.removeItem(key)
    else window.localStorage.setItem(key, value)
  } catch {
    // Without storage the value lasts until the page reloads.
  }
}
